// External
import React, { useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { Link, RouteComponentProps } from 'react-router-dom';

// Internal
import { People_ContactData } from '../types/graph/People_ContactData';
import paths from '../constants/routes.json';
import PeopleList from './People/PeopleList';
import { PlusIcon } from '@heroicons/react/outline';

// Component interface
interface IProps extends RouteComponentProps {}

const People: React.FC<IProps> = () => {
  /**
   * States
   */

  // Graph Query for ContactData
  const { data, loading, error } = useQuery<People_ContactData>(CONTACTS_QUERY);

  /**
   * Hooks
   */

  if (error) {
    console.error(error);
  }

  if (loading || !data || !data.contacts) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="md:flex md:items-center md:justify-between border-b pb-3">
        <div className="flex-1 min-w-0">
          <div>
            <h2 className="text-lg leading-6 font-medium text-gray-900">
              Contacts
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Overview of the internal contacts.
            </p>
          </div>
        </div>
        <div className="mt-4 flex md:mt-0 md:ml-4">
          {data.contacts?.length > 0 && (
            <Link
              to={`${paths.PEOPLE}/new`}
              type="button"
              className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-light"
            >
              <PlusIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
              Add New Contact
            </Link>
          )}
        </div>
      </div>
      <div className="mt-8">
        <PeopleList contacts={data.contacts!} />
      </div>
    </div>
  );
};

export default People;

/**
 * TODO: Create/Move to /Account/Account.graph.ts (Maybe - R&D required for graph queries strategy)
 */
export const CONTACTS_QUERY = gql`
  query People_ContactData {
    contacts {
      id
      person {
        name {
          first
          last
          full
        }
        email
        phones {
          number
          type
        }
        socialLinks {
          url
          type
        }
        avatar {
          filePath
        }
      }
      company {
        name
        title
        socialLinks {
          url
          type
        }
        logo {
          filePath
        }
      }
    }
  }
`;
